module.exports = __webpack_public_path__ + "ad5365f9.svg";